(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("examQuestionResource", ["$resource", examQuestionResource]);
    function examQuestionResource($resource) {
        return $resource("/api/exams/:number/questions/:questionNumber/:action", { number: "@number" }, {
            update: {
                method: "PUT"
            },
            copy: {
                method: "POST",
                params: { action: "copy" }
            },
            getExamQuestionViewModel: {
                method: "GET",
                params: { action: "examQuestionViewModel" }
            },
            reorderExamQuestions: {
                method: "POST",
                params: { action: "reorderExamQuestions" }
            },
            getManageExamQuestionsViewModel: {
                method: "GET",
                params: { action: "manageExamQuestionsViewModel" }
            },
            getExamSelectionModalQuestionsViewModel: {
                method: "GET",
                params: { action: "examSelectionModalQuestionsViewModel" }
            },
            saveExamQuestionHeader: {
                method: "POST",
                params: { action: "saveExamQuestionHeader" }
            },
            removeExamQuestionHeaderImage: {
                method: "POST",
                params: { action: "removeExamQuestionHeaderImage" }
            },
            importQuestions: {
                method: "POST",
                params: { action: "import" }
            }
        });
    }
}());
